export class AutofillOption {

    constructor(
        public name: string,
        public mode: string,
        public link: string
    ){}
}
